import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RoleAddEdit from "./RoleAddEdit";
import Button from "../../ui/Button";
import { AddIcon, DeleteIcon, EditIcon, SettingsIcon } from "../../utils/icon.utils";
import Table from "../../ui/Table/Table";
import { GroupBtn } from "../../ui/GroupBtn";
import { useDeleteRoleMutation, useGetAllRoleQuery } from "../../utils/role.utils";
import { tableIndex } from "../../utils/table.utils";
import { onConfirm } from "../../utils/sweetAlert.utils";
import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import { arrayMap } from "../../utils/array.utils";

export default function RolePage() {
  const navigate = useNavigate();
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [editItem, setEditItem] = useState(null);

  const [modal, setModal] = useState(false);

  const toggle = () => {
    if (modal) {
      setEditItem(null);
    }
    setModal((prev) => !prev);
  };

  const { loading, data } = useGetAllRoleQuery({
    query: `?page=${currentPage}&size=${pageSize}`
  });

  const { loading: deleting, deleteRole } = useDeleteRoleMutation(["deleteRole"]);

  const totalPage = data?.last_page === 1 && data?.total === 0 ? 0 : data?.last_page;

  const breadCrumbs = [
    {
      name: "Settings",
      link: "/settings"
    },
    {
      name: "Role"
    }
  ];

  const thead = ["#", "Name", "Slug", "Action"];

  const tbody =
    arrayMap(data?.data, (item, index) => ({
      "#": tableIndex(index, currentPage, pageSize),
      Name: item?.name ?? "-",
      Slug: item?.slug ?? "-",
      ...item
    })) || [];

  const ActionComponent = ({ data }) => {
    const handleEdit = (item) => {
      setEditItem(item);
      toggle();
    };

    const handleDelete = async (item) => {
      const { isConfirmed } = await onConfirm();
      if (isConfirmed) {
        await deleteRole(item?.id);
      }
    };

    const handleModuleView = (permissionItem) => {
      navigate(`${permissionItem?.slug}`);
    };

    const btns = [
      {
        icon: DeleteIcon,
        onClick: () => handleDelete(data),
        color: "danger"
      },
      {
        icon: EditIcon,
        onClick: () => handleEdit(data),
        color: "primary"
      },
      {
        icon: SettingsIcon,
        onClick: () => handleModuleView(data),
        color: "success"
      }
    ];
    return <GroupBtn btns={btns} justify="start" />;
  };

  const isLoading = loading || deleting;

  return (
    <PageLayout title="Role" subTitle={`Total: ${data?.total ?? 0}`} breadCrumbs={breadCrumbs}>
      <div className="text-end">
        <Button color="primary" icon={AddIcon} name="Create Role" onClick={toggle} />
      </div>

      {loading ? "Loading..." : ""}

      <Table
        thead={thead}
        tbody={tbody}
        action={ActionComponent}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPage={totalPage}
      />

      {modal && <RoleAddEdit modal={modal} toggle={toggle} editItem={editItem} />}
      {<Loading loading={isLoading} />}
    </PageLayout>
  );
}
